<script setup lang="ts">
import type { DictsysArticlePhraseHelper } from "@/helpers";

import LeArticlePhraseLink from "./LeArticlePhraseLink.vue";

const props = defineProps<{
  phrase: string;
  targets: DictsysArticlePhraseHelper.DictsysPhraseTarget[];
  type: DictsysArticlePhraseHelper.DictsysPhraseTargetType;
  sourceLanguage: string;
  targetLanguage: string;
}>();
</script>

<template>
  <div class="le-article-phrase-element">
    <span class="le-article-phrase-element__element le-article-phrase-element__phrase" :lang="props.sourceLanguage">
      {{ props.phrase }}
    </span>
    <span class="le-article-phrase-element__element le-article-phrase-element__phrase">&raquo;</span>
    <span
      :class="{
        'le-article-phrase-element__target-container': props.targets.length > 1,
        'le-article-phrase-element__element': props.targets.length === 0
      }"
    >
      <span
        v-for="(target, targetIndex) in props.targets"
        :key="targetIndex"
        class="le-article-phrase-element__list"
        :class="{ 'le-article-phrase-element__list--last': targetIndex === props.targets.length - 1 }"
      >
        <span
          :class="{
            'le-article-phrase-element__translation': props.type === 'translation',
            'le-article-phrase-element__example': props.type === 'example'
          }"
          :lang="props.targetLanguage"
          >{{ target.text }}</span
        ><span
          v-if="target.references.length > 0"
          :class="{
            'le-article-phrase-element__inner-element': target.text
          }"
          :lang="props.sourceLanguage"
          ><LeArticlePhraseLink
            text="se:"
            text-language="da"
            :references="target.references"
            :wrapped="target.text !== ''"
        /></span>
      </span>
    </span>
  </div>
</template>

<style lang="less" scoped>
@import "@dsk/styles/all";
@import "@/assets/styles/dictsys-article";

.le-article-phrase-element {
  color: @colors[@neutrals][500];
  .dictsys-article-text();

  &__inner-element {
    margin-left: 8px;
  }

  &__element {
    margin-right: 8px;
  }

  &__phrase {
    color: @colors[@primary][700];
    .dictsys-article-text--bold();
  }

  &__target-container {
    display: flex;
    flex-basis: 100%;
    flex-direction: column;
    margin-top: 14px;
    margin-bottom: 6px;
  }

  &__list {
    margin-bottom: 8px;

    &--last {
      margin-bottom: 0;
    }
  }

  &__translation {
    color: @colors[@neutrals][500];
    .dictsys-article-text--bold();
  }

  &__example {
    color: @colors[@neutrals][500];
  }
}
</style>
